'use client';

import { usePathname } from 'next/navigation';
import { type ReactNode } from 'react';

/**
 * Renders `children` only while the current pathname contains any of the
 * given `pathSegments`.
 *
 * Used by /listen/[slug] to wrap the descriptive hero passed into
 * `SearchPageClient`'s `resultsHeader` slot. When the user changes a filter
 * on a /listen page, `SearchPageClient` routes them to `/de/suche?...`. The
 * page subtrees re-mount, but during the transition the hero can briefly
 * remain visible at the new URL. Gating on pathname makes the disappearance
 * route-bound, not prop-bound.
 */
export default function PathScopedSlot({
  pathSegments,
  children,
}: {
  pathSegments: readonly string[];
  children: ReactNode;
}) {
  const pathname = usePathname();
  if (!pathname) return null;
  if (!pathSegments.some((seg) => pathname.includes(seg))) return null;
  return <>{children}</>;
}
